import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

/**
 * This is where you will add you feature flags to be used within the application.
 * When naming feature flags, opt for naming the same as the corresponding epic.
 * i.e: For epic "Neat Feature V1" name the flag -> "neatFeatureV1"
 *
 * Note that when adding a flag, create a corresponding ticket for removing the flag
 * all together.
 */
const FEATURE_FLAGS = ['msTeamsV1', 'managerReportAccess', 'engagementReportAccess'] as const

type FeatureFlagName = (typeof FEATURE_FLAGS)[number]

type FeatureFlagStore = {
  flags: Record<string, boolean>
}
const initFlags = () => {
  const flags: Record<string, boolean> = {}
  FEATURE_FLAGS.forEach(featureFlagName => {
    flags[featureFlagName] = false
  })
  return flags
}
const useFeatureFlagStore = create<FeatureFlagStore>()(
  persist(
    _ => ({
      flags: initFlags(),
    }),
    {
      name: 'featureFlag-storage',
      storage: createJSONStorage(() => localStorage),
    },
  ),
)

export const useFeatureFlags = () => {
  const { flags } = useFeatureFlagStore(state => ({
    flags: state.flags,
  }))

  return {
    isFeatureEnabled: (flagName: FeatureFlagName) => flags[flagName] || false,
  }
}

export default useFeatureFlags
